<template>
    <section>
        <div class="ui basic segment">
            <!-- <a :href="baseUrl" class="ui left basic button">
                <i class="reply icon"></i>Regresar
            </a> -->
            <h2 class="ui grey right floated header">
                <i class="building icon"></i>
                Empresas Dragón para Factoraje
            </h2>
        </div>
        <div class="ui form">
            <div class="fields">
                <div class="four wide field">
                    <label>R.F.C. o Nombre de la empresa</label>
                    <input type="text" placeholder="RFC o Nombre de la empresa" v-model="searchRecord.name" @keydown.enter="saveFilters(); searchRecords()">
                </div>
                <div class="six wide field">
                    <label>Estatus</label>
                    <sui-dropdown
                        fluid
                        multiple
                        :options="statusOptions"
                        placeholder="Estatus"
                        selection
                        v-model="searchRecord.statusId"
                    />
                    <!-- @input="searchRecords()" -->
                </div>

                <!--FILTRO POR PRODUCTO-->
                <div class="six wide field">
                    <label>Producto</label>
                    <sui-dropdown
                        fluid
                        multiple
                        :options="productsOptions"
                        placeholder="Producto"
                        selection
                        v-model="searchRecord.product"
                    />
                </div>

                <!--FILTRO POR TIPO-->
                <div class="six wide field">
                    <label>Tipo</label>
                    <sui-dropdown
                        fluid
                        multiple
                        :options="Utils.displayOptions(FactoringCompanyTypes)"
                        placeholder="Tipo"
                        selection
                        v-model="searchRecord.tipo"
                    />
                </div>

                <div class="four wide field">
                    <br>
                    <button class="ui left floated primary button" @click="saveFilters(); searchRecords()"><i class="search icon"></i>Buscar</button>
                    <button class="ui left floated button" @click="saveFilters(); restoreRecords()">Limpiar</button>
                </div>
            </div>
        </div>
        <button @click="addRecord()" class="ui right floated green button">Agregar</button><br><br>
        <div class="tableFixHead">
            <sui-table color="blue" selectable celled>
              <sui-table-header>
                <sui-table-row>
                  <sui-table-header-cell class="txtc" :width="2">RFC</sui-table-header-cell>
                  <sui-table-header-cell :width="4">Razón social</sui-table-header-cell>
                  <sui-table-header-cell :width="4">Nombre Comercial</sui-table-header-cell>
                  <sui-table-header-cell class="txtc" :width="1">Factoraje American</sui-table-header-cell>
                  <sui-table-header-cell class="txtc" :width="1">Blú Index</sui-table-header-cell>
                  <sui-table-header-cell class="txtc" :width="2">Tipo</sui-table-header-cell>
                  <sui-table-header-cell class="txtc" :width="2">Estatus</sui-table-header-cell>
                </sui-table-row>
              </sui-table-header>
              <sui-table-body>
                <sui-table-row v-if="records.length === 0">
                  <sui-table-cell class="txtc" colspan="7"><strong>No se encontraron registros</strong></sui-table-cell>
                </sui-table-row>
                <sui-table-row v-for="record in records" :key="record.companyId" @click="detailRecord(record.id)">
                  <sui-table-cell class="txtc">{{ record.rfc }}</sui-table-cell>
                  <sui-table-cell>{{ record.razonSocial }}</sui-table-cell>
                  <sui-table-cell>{{ record.nombreComercial }}</sui-table-cell>
                  <sui-table-cell class="txtc" v-if="record.factorajeBlu"><i class="green check icon"></i></sui-table-cell>
                  <sui-table-cell class="txtc" v-else><i class="red times icon"></i></sui-table-cell>
                  <sui-table-cell class="txtc" v-if="record.bluIndex"><i class="ui green check icon"></i></sui-table-cell>
                  <sui-table-cell class="txtc" v-else><i class="red times icon"></i></sui-table-cell>
                  <sui-table-cell class="txtc">
                      <h5 class="ui header">
                          {{ Utils.displayOptionName(FactoringCompanyTypes, record.tipo) }}
                      </h5>
                  </sui-table-cell>
                  <sui-table-cell class="txtc">
                      <h5 class="ui header" :class="Utils.getStatusInfo(record.statusId).color">
                          {{ Utils.getStatusInfo(record.statusId).name }}
                      </h5>
                  </sui-table-cell>
                </sui-table-row>
              </sui-table-body>
              <sui-table-footer>
                <sui-table-row >
                  <sui-table-header-cell colspan="7" text-align="right">
                    <Pagination :total="total" :page-size="searchRecord.pageSize" :callback="loadRecords"/>
                  </sui-table-header-cell>
                </sui-table-row>
              </sui-table-footer>
            </sui-table>
        </div>
    </section>
</template>

<script>
import FactoringCompanyService from '@/services/FactoringCompanyService'
import Pagination from '@/components/Helpers/Pagination.vue'
import Utils from '@/common/Utils.js'
import FactoringCompanyStatus from '@/common/FactoringCompanyStatus.js'
import FactoringCompanyTypes from '@/common/FactoringCompanyTypes.js'

export default {
    name: 'FactoringCompanyList',
    components: { Pagination },

    data () {
        return {
            Utils,
            FactoringCompanyTypes,
            statusOptions: [
                { value: FactoringCompanyStatus.APPROVED, text: Utils.getStatusInfo(FactoringCompanyStatus.APPROVED).name },
                { value: FactoringCompanyStatus.PENDING, text: Utils.getStatusInfo(FactoringCompanyStatus.PENDING).name },
                { value: FactoringCompanyStatus.REJECTED, text: Utils.getStatusInfo(FactoringCompanyStatus.REJECTED).name },
                { value: FactoringCompanyStatus.RESTRICTED, text: Utils.getStatusInfo(FactoringCompanyStatus.RESTRICTED).name }
            ],
            productsOptions: [
                { value: 'blu_index', text: 'Blú Index' },
                { value: 'factoraje_blu', text: 'Factoraje American' }
            ],
            typesOptions: [
                { value: FactoringCompanyTypes.NO_DRAGON, text: Utils.displayOptionName(FactoringCompanyTypes, FactoringCompanyTypes.NO_DRAGON) },
                { value: FactoringCompanyTypes.DRAGON, text: Utils.displayOptionName(FactoringCompanyTypes, FactoringCompanyTypes.DRAGON) }
            ],
            searchRecord: {
                page: 1,
                pageSize: 25,
                order: 'ASC',
                statusId: [],
                product: []
            },
            total: 0,
            records: []
        }
    },

    beforeMount () {
        if (!this.$store.getters.isLoggedIn) {
            window.location.replace('/login')
        }
    },

    mounted () {
        if (this.$store.getters.filters['factoringCompanies'] && Object.keys(this.$store.getters.filters['factoringCompanies']).length) {
            this.searchRecord = Object.assign({}, this.$store.getters.filters['factoringCompanies'])
        }

        this.loadRecords(1)
    },

    methods: {
        saveFilters () {
            const data = Object.assign({}, this.searchRecord)
            this.$store.dispatch('setFilters', { recordName: 'factoringCompanies', data })
        },

        searchRecords () {
            this.searchRecord.page = 1
            this.loadRecords(1)
        },

        restoreRecords () {
            this.searchRecord = {
                page: 1,
                pageSize: 25,
                order: 'ASC',
                statusId: [],
                product: []
            }
            this.loadRecords(1)
        },

        async loadRecords (page) {
            let loader = this.$loading.show()
            this.records = []
            if (page && typeof (page) !== 'object') {
                this.searchRecord.page = page
            }
            try {
                ({ items: this.records, count: this.total } = await FactoringCompanyService.getAll(this.searchRecord))
                loader.hide()
            } catch (error) {
                loader.hide()
                console.error(error)
            }
        },

        detailRecord (id) {
            this.$router.push({ path: '/settings/empresa-dragon-detail/' + id })
        },

        addRecord () {
            if (!Utils.userHasPerm('can_add_factoring_company')) {
                this.$swal({
                    title: 'Error',
                    text: 'No tienes permiso para realizar la accion',
                    type: 'error'
                })
                return
            }
            this.$router.push({ path: '/settings/empresa-dragon-detail/' })
        }
    }
}
</script>

<style scoped>
    .ui table { margin-top: 20px; }
/*    .tableFixHead {
        margin-top: 30px;
        overflow-y: auto;
        height: 600px;
    }
    .tableFixHead thead th {
        position: sticky;
        top: 0;
    }*/
</style>
